export default {
  user: state => {
    return state.user
  },

  // devices
  devices: state => {
    return state.devices
  },
  devicesOrderByIsSet: state => {
    return state.devices.sort((a, b) => {
      if (a.is_set === b.is_set) {
        return 0
      }
      return a.is_set ? -1 : 1
    })
  },
  searchDevice: state => deviceId => {
    return state.devices.find(d => d.id === deviceId)
  },
  userDevices: state => {
    return state.devices.filter(d => d.is_set)
  },

  // infodevice
  infoDeviceId: state => {
    return state.infoDeviceId
  },
  infoDevice: state => {
    if (state.infoDeviceId === '') {
      return {
        id: '',
        position: {
          lat: 0,
          lng: 0
        },
        name: '',
        is_alert: false,
        is_set: false,
        is_notification_disabled: false,
        alert_disabled_time: 0
      }
    }
    return state.devices.find(d => d.id === state.infoDeviceId)
  },

  // settings
  notificationIntervalHour: state => {
    return state.notificationIntervalHour
  },

  // provider
  provider: state => {
    return state.provider
  },

  reloadMap: state => {
    return state.reloadMap
  }
}
